export const az = {
  title: 'Landsat-8 / Sentinel-2 Satellite Imagery',
  content: [
    {
      label: 'Funksiya',
      value:
        'Yüksək ayırdetmə qabiliyyətinə malik peyk təsvirləri GFW-də mövcud olan digər məlumat qatlarına kontekst təmin etmək üçün vacibdir, məsələn, ağac örtüyünün dəyişməsinin səbəblərini şərh etmək. O, adətən yaxın real vaxtda meşələrin qırılması ilə bağlı xəbərdarlıqların mümkün səbəblərini müəyyən etmək üçün istifadə olunur. Şəkillər həmçinin torpaq/meşə örtüyünün düzgünlüyünü qiymətləndirmək və məhsulları dəyişdirmək üçün təsdiqləmə protokollarında istifadə edilə bilər.',
    },
    {
      label: 'Qətmə',
      value: 'Sentinal-2: 10 x 10 metr, Landsat 8: 30 x 30 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value:
        'Kopernik Sentinel-2. Google Earth Engine-dən alındı. Məlumat Avropa Kosmik Agentliyi (ESA) tərəfindən işlənib.',
    },
    {
      label: 'Tezlik',
      value:
        'Hər gün yeni şəkillər əlçatan olur. Şəkilə yenidən baxma vaxtı: Sentinel-2A: Hər 10 gündən bir, Landsat 8: Hər 16 gündən bir',
    },
    {
      label: 'Məzmun tarixi',
      value: 'Yanvar 2012 - mətbuat.',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Bu məlumatlar Sentinel-2 və Landsat 8 sistemlərindən seçilmiş bulud örtüyü meyarlarına cavab verən ən son peyk şəkillərini göstərir. . Avropa Kosmik Agentliyi tərəfindən idarə olunan Sentinel-2 10 metrlik təsvir ölçüsündə qlobal əhatə dairəsinə malikdir və hər 10 gündən bir yenilənən görüntüləri əldə edə bilir. ABŞ Geoloji Tədqiqat Xidməti tərəfindən idarə olunan Landsat 8 də qlobal peykdir və hər 16 gündən bir 30 metrlik qətnamə ilə yenilənmiş görüntüləri əldə edə bilir. Təbii rəngi və bitki örtüyünün sağlamlığını əks etdirən görüntülər hər iki peykdən əldə edilə bilər. Təbii rəngli şəkillər Yerin səthini insan gözünə göründüyü kimi göstərmək üçün görünən işıqdan (qırmızı, yaşıl və mavi) alınan məlumatlardan istifadə edir. Bitki örtüyünün sağlamlığı həm qırmızı, həm də yaxın infraqırmızı əksetmə haqqında məlumatları özündə birləşdirən Normallaşdırılmış Fərqli Bitki Örtüsü İndeksindən (NDVI) istifadə etməklə aşkar edilir. Bu üsul, sağlam bitki örtüyünün ən çox görünən işığı qəbul etməsinə və səthinə düşən ən yaxın infraqırmızı işığı əks etdirməsinə əsaslanır. Bitki sağlamlığını göstərən təsvirləri şərh edərkən, qırmızı sağlam böyüyən bitkiləri, yaşıl çılpaq torpağı, qara isə su obyektlərini göstərir.',
  },
};
